import React, { useState } from "react";
import Header from "../../components/HeaderNew";
import { Button, requirePropFactory } from "@material-ui/core";
import Footer from "../FooterNew";
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import { Section } from "react-scroll-section";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Pagination, Navigation } from "swiper/modules";

// import useStateRef from "react-usestateref";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Ownblockchain() {
  const [open, isopen] = useState(false);
  const [open1, isopen1] = useState(false);
  const [open2, isopen2] = useState(false);
  const [open3, isopen3] = useState(false);
  const [open4, isopen4] = useState(false);

  const processes_newew = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  const [isShown, setIsShown] = useState(false);

  const handleClick = () => {
    setIsShown(!isShown);
  };

  return (
    <div className="own_block_chain_development_page">
      <header className="newpage">
        {/* <Header /> */}
        <NewHead />
      </header>
      <div className="paddin_immner">
        <main className="own_block_chain_development_company_page">
          <span className="own_block_chain_development_company_main">
            <Helmet>
              <title>Build your own blockchain</title>
              <link
                rel="canonical"
                href="https://www.beleaftechnologies.com/own-blockchain-development-company"
              />
              <meta name="title" content="Build your own blockchain" />
              <meta
                name="description"
                content="Our company specializes in creating own blockchain development for your specific needs. Whether you are a startup, a small business, or a large enterprise, we are here to help you unlock the potential of blockchain and transform your operations."
              />
            </Helmet>
            <section className="own_blockchain_hero_section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-7">
                    <div className="own_blockchain_hero_content">
                      <h1>Build your own blockchain</h1>
                      <p>
                        Welcome to the world's no 1 Own Blockchain Development
                        Company ! If you are looking to use the power of
                        blockchain technology for your business, you’ve come to
                        the right place.
                      </p>

                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Contact Us"
                        className="own_blockchain_get_demo_btn"
                      >
                        Get Demo <i className="ri-arrow-right-line"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="what-is_own_blockchain_section">
              <div className="container">
                <div className="row align-content-center">
                  <div className="col-lg-6">
                    <div className="what-is_own_blockchain_banner">
                      <img
                        src={require("../../image/Own_Blockchain/what_is_own_blockchain_banner.webp")}
                        alt="Own Blockchain Development Company"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="what_is_own_blockchain_content">
                      <h2>
                        What is Own <br />
                        Blockchain Development?
                      </h2>
                      <p>
                        Own blockchain development refers to the process of
                        developing a blockchain to meet the exact requirements
                        of an entity or organization.{" "}
                      </p>
                      <p>
                        Unlike public blockchains like Bitcoin or Ethereum,
                        which are open to anyone, an own blockchain is designed
                        exclusively for a particular entity or organisation.
                        This allows for security, greater control, and
                        customization.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="own_blockchain_key_features_section">
              <div className="container">
                <div className="own_blockchain_key_features_title">
                  <h2>
                    Key Features of <br />
                    Our Own Blockchain Development
                  </h2>
                </div>
                <div className="specification-of-development-section revenue_mechanisms_section type_own_blockchain own_block_chain_features_key">
                  <>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={50}
                      navigation={true}
                      modules={[Navigation]}
                      pagination={{
                        clickable: true,
                      }}
                      breakpoints={{
                        640: {
                          slidesPerView: 1,
                          spaceBetween: 20,
                        },
                        768: {
                          slidesPerView: 2,
                          spaceBetween: 40,
                        },
                        1024: {
                          slidesPerView: 3, // Adjust the number of slides visible
                          spaceBetween: 60, // Adjust the space between slides
                        },
                        1280: {
                          slidesPerView: 3,
                          spaceBetween: 60,
                        },
                      }}
                      className="mySwiper flash-slider"
                    >
                      <SwiperSlide>
                        <div className="type-public-blockchain">
                          <img
                            src={require("../../image/Own_Blockchain/Customization.webp")}
                            alt="Own Blockchain Development Company"
                          />{" "}
                          <h3>Customization</h3>
                          <p>
                            You can develop the blockchain to suit your specific
                            needs, from transaction processing to governance
                            models.
                          </p>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="type-public-blockchain">
                          <img
                            src={require("../../image/Own_Blockchain/Security.webp")}
                            alt="Own Blockchain Development Company"
                          />
                          <h3>Security</h3>
                          <p>
                            With your own blockchain, you can implement advanced
                            security measures to protect your data and
                            transactions.
                          </p>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="type-public-blockchain">
                          <img
                            src={require("../../image/Own_Blockchain/Efficiency.webp")}
                            alt="Own Blockchain Development Company"
                          />
                          <h3>Efficiency</h3>
                          <p>
                            Own blockchain development can be optimized for
                            performance, ensuring fast and efficient transaction
                            processing.
                          </p>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="type-public-blockchain">
                          <img
                            src={require("../../image/Own_Blockchain/Control.webp")}
                            alt="Own Blockchain Development Company"
                          />
                          <h3>Control</h3>
                          <p>
                            You have complete control over the blockchain
                            network, including who can participate and how it
                            operates.
                          </p>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="type-public-blockchain">
                          <img
                            src={require("../../image/Own_Blockchain/scalability.webp")}
                            alt="Own Blockchain Development Company"
                          />
                          <h3>Scalability</h3>
                          <p>
                            Own blockchains can be designed to scale according
                            to your business growth and needs.
                          </p>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </>
                </div>
              </div>
            </section>
            <section className="how_to_choose_own_blockchain_section">
              <div className="container">
                <div className="how_to_choose_own_blockchain_title">
                  <h2>
                    <span>How to Choose an </span>
                    <br />
                    Own Blockchain Development Company
                  </h2>
                  <p>
                    Selecting the right own blockchain development company is
                    crucial to the
                    <br /> success of your project. some key factors to consider
                    are
                  </p>
                </div>
                <div className="row">
                  <div className="col-lg-7">
                    <div className="blockchain_expertise_card">
                      <div className="blockchain_expertise_card_title">
                        <img
                          src={require("../../image/Own_Blockchain/Expertise.webp")}
                          alt="Own Blockchain Development Company"
                        />
                        <h3>Expertise and Experience</h3>
                      </div>
                      <p>
                        Choose a company with a proven track record in Own
                        blockchain development. Check their portfolio to see the
                        types of projects they have worked on and their level of
                        expertise in different blockchain technologies.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="blockchain_expertise_card flexibility">
                      <div className="blockchain_expertise_card_title">
                        <img
                          src={require("../../image/Own_Blockchain/customization_flexibility.webp")}
                          alt="Own Blockchain Development Company"
                        />
                        <h3>
                          Customization and
                          <br /> Flexibility
                        </h3>
                      </div>
                      <p>
                        Your business is unique, and so your requirements must
                        be unique. Choose a Own blockchain development company
                        that offers customised solutions. They should be
                        flexible in their approach and willing to adapt to your
                        requirements.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="blockchain_expertise_card flexibility">
                      <div className="blockchain_expertise_card_title">
                        <img
                          src={require("../../image/Own_Blockchain/security_measures.webp")}
                          alt="Own Blockchain Development Company"
                        />
                        <h3>
                          Security <br />
                          Measures
                        </h3>
                      </div>
                      <p>
                        Security is a must in blockchain development. Ensure the
                        company you choose implements robust security measures
                        to protect your data and transactions. They should
                        follow best practices in blockchain security and have
                        experience in dealing with security challenges.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="blockchain_expertise_card flexibility">
                      <div className="blockchain_expertise_card_title">
                        <img
                          src={require("../../image/Own_Blockchain/Comprehensive.webp")}
                          alt="Own Blockchain Development Company"
                        />
                        <h3>
                          Comprehensive
                          <br />
                          Services
                        </h3>
                      </div>
                      <p>
                        A good blockchain development company should offer
                        end-to-end services, from consulting and strategy to
                        design, development, and implementation. This ensures a
                        hassle free and efficient process, reducing the risk of
                        delays and complications.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="blockchain_expertise_card flexibility">
                      <div className="blockchain_expertise_card_title">
                        <img
                          src={require("../../image/Own_Blockchain/support.webp")}
                          alt="Own Blockchain Development Company"
                        />
                        <h3>
                          Support and
                          <br />
                          Maintenance
                        </h3>
                      </div>
                      <p>
                        Blockchain technology is constantly developing, and your
                        blockchain solution will need regular updates and
                        maintenance. Choose a company that offers ongoing
                        support and maintenance services to ensure your
                        blockchain continues to perform optimally.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="own_blockchain_key_features_section use_cases_own_blockchain_development_section ">
              <div className="container">
                <div className="own_blockchain_key_features_title">
                  <h2>
                    Use Cases of <br />
                    Own Blockchain Development
                  </h2>
                  <p>
                    Own blockchain development can be applied across various
                    industries to
                    <br /> improve efficiency, security, and transparency.
                    <br />
                    <span className="here_use_case">
                      Here are some use cases:
                    </span>
                  </p>
                </div>
                <div className="specification-of-development-section revenue_mechanisms_section type_own_blockchain use_cases_own_blockchain_development ">
                  <>
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={20}
                      navigation={true}
                      modules={[Navigation]}
                      pagination={{
                        clickable: true,
                      }}
                      breakpoints={{
                        640: {
                          slidesPerView: 1,
                          spaceBetween: 20,
                        },
                        700: {
                          slidesPerView: 2,
                          spaceBetween: 40,
                        },
                        1024: {
                          slidesPerView: 3, // Adjust the number of slides visible
                          spaceBetween: 60, // Adjust the space between slides
                        },
                        1280: {
                          slidesPerView: 4,
                          spaceBetween: 10,
                        },
                      }}
                      className="mySwiper flash-slider"
                    >
                      <SwiperSlide>
                        <div className="flip-card">
                          <div className="flip-card-inner">
                            <div className="flip-card-front use_cases_own_blockchain_card">
                              <img
                                src={require("../../image/Own_Blockchain/supply_chain.webp")}
                                alt="Own Blockchain Development Company"
                              />
                              <h3>Supply Chain </h3>
                            </div>
                            <div className="flip-card-back">
                              <p>
                                Blockchain technology can change supply chain
                                management by providing a transparent and
                                immutable record of transactions. This helps in
                                tracking products from origin to delivery,
                                reducing fraud, and improving efficiency.
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="flip-card">
                          <div className="flip-card-inner">
                            <div className="flip-card-front use_cases_own_blockchain_card">
                              <img
                                src={require("../../image/Own_Blockchain/Finance.webp")}
                                alt="Avatar"
                              />
                              <h3>
                                Finance and
                                <br /> Banking
                              </h3>
                            </div>
                            <div className="flip-card-back">
                              <p>
                                In the finance and banking sector, blockchain
                                can enhance security and reduce transaction
                                costs. It can be used for cross-border payments,
                                smart contracts, and fraud detection.
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="flip-card">
                          <div className="flip-card-inner">
                            <div className="flip-card-front use_cases_own_blockchain_card">
                              <img
                                src={require("../../image/Own_Blockchain/Healthcare.webp")}
                                alt="Own Blockchain Development Company"
                              />
                              <h3>Healthcare</h3>
                            </div>
                            <div className="flip-card-back">
                              <p>
                                Blockchain can improvise data security in the
                                healthcare industry. It can be used for managing
                                patient records, ensuring data integrity and
                                streamlining administrative processes.
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="flip-card">
                          <div className="flip-card-inner">
                            <div className="flip-card-front use_cases_own_blockchain_card">
                              <img
                                src={require("../../image/Own_Blockchain/real_estate.webp")}
                                alt="Own Blockchain Development Company"
                              />
                              <h3>Real Estate</h3>
                            </div>
                            <div className="flip-card-back">
                              <p>
                                In real estate, blockchain can simplify property
                                transactions and improve transparency. It can be
                                used for property listings, title transfers, and
                                lease agreements.
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="flip-card">
                          <div className="flip-card-inner">
                            <div className="flip-card-front use_cases_own_blockchain_card">
                              <img
                                src={require("../../image/Own_Blockchain/Voting.webp")}
                                alt="Own Blockchain Development Company"
                              />
                              <h3>Voting Systems</h3>
                            </div>
                            <div className="flip-card-back">
                              <p>
                                Blockchain can enhance the strength and
                                transparency of voting systems. It can be used
                                for secure and verifiable online voting,
                                reducing the risk of fraud and ensuring the
                                accuracy of results.
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </>
                </div>
              </div>
            </section>
            <section className="specification-of-development-section revenue_mechanisms_section type_own_blockchain public_block_chain_slide card_height_ownblockchain">
              <div className="container">
                <div className="row align_center_content">
                  <div className="col-lg-5">
                    <div className="type_of_own_blockchain_content">
                      <h2>
                        <span>Types of </span> <br />
                        Blockchains We Develop
                      </h2>
                      <p>
                        At Beleaf Technologies, we specialize in developing
                        various types of blockchain solutions. Our expertise
                        ensures that you get the best own blockchain solution
                        that fits your specific requirements. Here are the main
                        types of blockchains we develop.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-7">
                    <div>
                      <>
                        <Swiper
                          slidesPerView={1}
                          spaceBetween={10}
                          navigation={true}
                          modules={[Navigation]}
                          pagination={{
                            clickable: true,
                          }}
                          breakpoints={{
                            640: {
                              slidesPerView: 1,
                              spaceBetween: 20,
                            },
                            768: {
                              slidesPerView: 2,
                              spaceBetween: 40,
                            },
                            1024: {
                              slidesPerView: 2,
                              spaceBetween: 50,
                            },
                          }}
                          className="mySwiper flash-slider"
                        >
                          <SwiperSlide>
                            {open === false ? (
                              <div className="types_of_blockchains_we_develop">
                                <h3>Public Blockchains</h3>
                                <button onClick={() => isopen(!open)}>
                                  Learn More<i className="ri-arrow-right-line"></i>
                                </button>
                                <img
                                  src={require("../../image/Own_Blockchain/type-1.webp")}
                                  alt="Own Blockchain Development Company"
                                />
                              </div>
                            ) : (
                              <div
                                className="types_of_blockchains_we_develop_content"
                                onClick={() => isopen(!open)}
                              >
                                <span>Public blockchains</span> are open to
                                anyone and are decentralized, meaning no single
                                person or organisation has control over the
                                network. Transactions are transparent and can be
                                verified by any participant. Public blockchains
                                are ideal for applications that require high
                                levels of transparency and decentralization,
                                such as cryptocurrencies (e.g., Bitcoin,
                                Ethereum).
                              </div>
                            )}
                          </SwiperSlide>
                          <SwiperSlide>
                            {open1 === false ? (
                              <div className="types_of_blockchains_we_develop">
                                <h3>Private Blockchains</h3>
                                <button onClick={() => isopen1(!open1)}>
                                  Learn More<i className="ri-arrow-right-line"></i>
                                </button>
                                <img
                                  src={require("../../image/Own_Blockchain/type-2.webp")}
                                  alt="Own Blockchain Development Company"
                                />
                              </div>
                            ) : (
                              <div
                                className="types_of_blockchains_we_develop_content"
                                onClick={() => isopen1(!open1)}
                              >
                                <span>Private blockchains</span> are restricted
                                to specific participants. They are controlled by
                                a single organization, which grants access and
                                permissions. Private blockchains are ideal for
                                businesses that need to maintain control over
                                their data while benefiting from the security
                                and efficiency of blockchain technology.
                              </div>
                            )}
                          </SwiperSlide>
                          <SwiperSlide>
                            {open2 === false ? (
                              <div className="types_of_blockchains_we_develop">
                                <h3>Consortium Blockchains</h3>
                                <button onClick={() => isopen2(!open2)}>
                                  Learn More<i className="ri-arrow-right-line"></i>
                                </button>
                                <img
                                  src={require("../../image/Own_Blockchain/type-3.webp")}
                                  alt="Own Blockchain Development Company"
                                />
                              </div>
                            ) : (
                              <div
                                className="types_of_blockchains_we_develop_content"
                                onClick={() => isopen2(!open2)}
                              >
                                <span>Consortium blockchains</span> a are
                                partially decentralized and managed by a group
                                of organizations rather than a single entity.
                                They are ideal for business collaborations where
                                multiple organizations need to work together but
                                still want to maintain some level of control
                                over the network.
                              </div>
                            )}
                          </SwiperSlide>
                          <SwiperSlide>
                            {open3 === false ? (
                              <div className="types_of_blockchains_we_develop">
                                <h3>Hybrid Blockchains</h3>
                                <button onClick={() => isopen3(!open3)}>
                                  Learn More<i className="ri-arrow-right-line"></i>
                                </button>
                                <img
                                  src={require("../../image/Own_Blockchain/type-4.webp")}
                                  alt="Own Blockchain Development Company"
                                />
                              </div>
                            ) : (
                              <div
                                className="types_of_blockchains_we_develop_content"
                                onClick={() => isopen3(!open3)}
                              >
                                <span>Hybrid blockchains</span> combine the
                                features of both Private and Public blockchains.
                                They allow organizations to control who can
                                access specific data while still making some
                                data public. This type of blockchain offers the
                                best of both worlds: the transparency of public
                                blockchains and the control of private
                                blockchains.
                              </div>
                            )}
                          </SwiperSlide>
                          <SwiperSlide>
                            {open4 === false ? (
                              <div className="types_of_blockchains_we_develop">
                                <h3>Sidechains</h3>
                                <button onClick={() => isopen4(!open4)}>
                                  Learn More<i className="ri-arrow-right-line"></i>
                                </button>
                                <img
                                  src={require("../../image/Own_Blockchain/type-5.webp")}
                                  alt="Own Blockchain Development Company"
                                />
                              </div>
                            ) : (
                              <div
                                className="types_of_blockchains_we_develop_content"
                                onClick={() => isopen4(!open4)}
                              >
                                <span>Sidechains</span> are open to anyone and
                                are decentralized, meaning no single person or
                                organisation has control over the network.
                                Transactions are transparent and can be verified
                                by any participant. Public blockchains are ideal
                                for applications that require high levels of
                                transparency and decentralization, such as
                                cryptocurrencies (e.g., Bitcoin, Ethereum).
                              </div>
                            )}
                          </SwiperSlide>
                        </Swiper>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="get_started_own_block_section">
              <div className="container">
                <div className="get_started_own_block_content">
                  <h2>
                    <span>Get Started </span>
                    <br />
                    With Beleaf Technologies
                  </h2>
                  <p>
                    Ready to use the power of own blockchain for your business?
                    Contact us today to schedule a consultation
                    <br /> and learn how Beleaf Technologies can help you
                    achieve your goals. Our team is here to provide expert
                    <br /> guidance and support, ensuring your own blockchain
                    development project is a success.
                  </p>
                  <Button
                    data-toggle="modal"
                    data-target="#myModal"
                    aria-label="Contact Us"
                    className="own_blockchain_get_demo_btn"
                  >
                    Get Started <i className="ri-arrow-right-line"></i>
                  </Button>
                </div>
              </div>
            </section>
            <Section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row align_center_content">
                    <div className="col-lg-6 align-items-center">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    What is blockchain technology?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Blockchain technology is a secure
                                    decentralised digital ledger that records
                                    transactions across multiple nodes. It
                                    ensures data privacy and transparency.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    How does own blockchain development benefit
                                    business?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Own blockchain development can enhance
                                    security, improve efficiency, and increase
                                    transparency in various business processes,
                                    reducing costs and improving trust.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    How long does it take to develop a Own
                                    blockchain solution?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    The development time depends on the
                                    complexity and requirements of the project.
                                    On average, it can take a few weeks to a
                                    month.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    What industries can benefit from Own
                                    blockchain development?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Own blockchain development can benefit
                                    industries such as finance, healthcare,
                                    supply chain, real estate, and more by
                                    improving security, efficiency, and
                                    transparency.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </Section>
          </span>
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Ownblockchain;
